var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_expand_more_24px","d":"M24.628,8.59l-8.074,8.056L8.48,8.59,6,11.07,16.554,21.624,27.108,11.07Z","transform":"translate(-6 -8.59)","fill":"#fff"}));
}

ChevronDown.defaultProps = {"width":"21.108","height":"13.034","viewBox":"0 0 21.108 13.034"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
